import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["srcdoc"]
const _hoisted_3 = { class: "dialog-footer" }

import { ref } from "vue";
import ReportService from "../../services/ReportService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationDetail',
  setup(__props, { expose: __expose }) {

const dialogVisible = ref(false);
const dialogRef = ref(null);
const data = ref(Array<any>());
const htmlCode = ref(null);
const isLoading = ref(false);
const show = (item: any) => {
  dialogVisible.value = true;
  data.value = item;
  fetchData();
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await ReportService.queryAccountReportPreviewById(
      data.value.id
    );
    htmlCode.value = res;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};
__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    title: "Report Preview",
    width: "80%",
    class: "min-h-300px",
    ref_key: "dialogRef",
    ref: dialogRef,
    "align-center": "",
    draggable: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingRing)
          ]))
        : (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            srcdoc: htmlCode.value,
            width: "100%",
            height: "800"
          }, null, 8, _hoisted_2))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})